import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { BaseEntity, Currency, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { WiseTransferStatus } from './wise.transfer.status.enum';

export const WiseTransferSchema = WithBaseEntitySchema(
    z.object({
        wiseRecipientId: z.string(),
        transferId: z.string().nullish(),
        profileId: z.string(),
        deduplicationId: z.string(),
        transactionId: z.string().nullish(),
        funds: z.string().nullish(),
        status: z.string(EnumSchema(WiseTransferStatus)),
        amount: z.number(),
        currency: z.string(EnumSchema(Currency)),
    }),
).strict();

export class WiseTransfer extends FromSchema(WiseTransferSchema) implements BaseEntity {
    id: string;
    wiseRecipientId: string;
    transferId: string;
    profileId: string;
    deduplicationId: string;
    transactionId?: string;
    funds?: string;
    status: WiseTransferStatus;
    amount: number;
    currency: Currency;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    tenantId: string;
    seller?: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
